module.exports = __webpack_public_path__ + "img/gallery-image-03.05d106bd.png";